<main class="cmp-page">
  <section class="cmp__container">
    <header class="cmp__header">
      <div>
        <h1>{{ 'cmp.title' | translate }}</h1>
        <p>{{ 'cmp.subtitle' | translate }}</p>
      </div>
      <button type="button"
              class="primary-btn"
              (click)="openCreatePanel()">
        {{ 'cmp.actions.new' | translate }}
      </button>
    </header>


    <div class="cmp__filters surface-card">
      <div class="cmp__filter-field">
        <label>{{ 'cmp.filters.search' | translate }}</label>
        <div class="cmp__filter-control">
          <input type="search"
                 [value]="searchTerm"
                 [placeholder]="'cmp.filters.searchPlaceholder' | translate"
                 (input)="onSearch($any($event.target).value)">
          <button type="button"
                  class="ghost-btn compact"
                  *ngIf="searchTerm"
                  (click)="clearSearch()">×</button>
        </div>
      </div>
    </div>

    <div class="cmp__layout">
      <div class="cmp__card surface-card">
        <div class="cmp__table-wrapper">
          <div class="cmp__table-header" *ngIf="!isLoading && !loadingError && filteredConfigs.length">
            <span>{{ 'cmp.table.name' | translate }}</span>
            <span>{{ 'cmp.table.language' | translate }}</span>
            <span>{{ 'cmp.table.vendors' | translate }}</span>
            <span>{{ 'cmp.table.providers' | translate }}</span>
            <span>{{ 'cmp.table.status' | translate }}</span>
            <span class="cmp__header-spacer" aria-hidden="true"></span>
          </div>

          <div class="cmp__list">
            <p class="list-status" *ngIf="isLoading">{{ 'common.loading' | translate }}</p>
            <p class="list-status error" *ngIf="!isLoading && loadingError">{{ loadingError }}</p>

            <ng-container *ngIf="!isLoading && !loadingError && filteredConfigs.length; else emptyState">
              <div class="cmp__row" *ngFor="let config of paginatedConfigs">
                <span>
                  <div class="cmp__cell-title">{{ config.Name }}</div>
                  <div class="cmp__cell-subtitle">ID: {{ config.ID }}</div>
                </span>
                <span class="cmp__lang-cell">
                  <span class="lang-badge">{{ config.ConsentLanguage }}</span>
                  <span class="cmp__cell-subtitle">GVL v{{ config.VendorListVersion }}</span>
                </span>
                <span class="cmp__vendors-cell">{{ getVendorsLabel(config) }}</span>
                <span>
                  <div class="cmp__providers-cell">
                    <span class="cmp__provider-count">{{ config.Providers.length || 0 }}</span>
                    <ng-container *ngIf="config.Providers.length">
                      <ng-container *ngFor="let provider of config.Providers">
                        <span class="deploy-badge deploy-badge--clickable"
                              [ngClass]="getDeployStatusClass(provider.DeployStatus)"
                              [title]="('cmp.snippet.badgeTooltip' | translate) + ' — ' + getDeployStatusLabel(provider.DeployStatus)"
                              (click)="openSnippetModal($event, config, provider)">
                          {{ getProviderName(provider.ProviderID) }}
                          <span *ngIf="isProviderOutdated(config, provider)"
                                class="outdated-badge"
                                [title]="'cmp.outdated.tooltip' | translate">⚠</span>
                        </span>
                      </ng-container>
                    </ng-container>
                  </div>
                </span>
                <span>
                  <span class="status-badge" [ngClass]="config.Status === 1 ? 'status-badge--active' : 'status-badge--inactive'">
                    {{ config.Status === 1 ? ('cmp.fields.statusActive' | translate) : ('cmp.fields.statusInactive' | translate) }}
                  </span>
                </span>
                <div class="cmp__actions">
                  <button type="button"
                          class="action-menu-btn"
                          (click)="openActionMenu($event, config)"
                          [attr.aria-expanded]="activeActionMenuId === config.ID">
                    ···
                  </button>
                </div>
              </div>
            </ng-container>

            <ng-template #emptyState>
              <div class="cmp__empty" *ngIf="!isLoading && !loadingError">
                <p>{{ 'cmp.empty' | translate }}</p>
              </div>
            </ng-template>
          </div>
        </div>

        <div class="cmp__pagination" *ngIf="filteredConfigs.length > 0">
          <div class="pagination-size">
            <label>{{ 'common.pagination.rowsPerPage' | translate }}</label>
            <select [value]="pageSize" (change)="setPageSize(+$any($event.target).value)">
              <option *ngFor="let s of pageSizeOptions" [value]="s">{{ s }}</option>
            </select>
          </div>
          <span class="pagination-info">
            {{ currentPage * pageSize + 1 }}–{{ Math.min((currentPage + 1) * pageSize, filteredConfigs.length) }}
            {{ 'common.pagination.of' | translate }} {{ filteredConfigs.length }}
          </span>
          <div class="pagination-controls">
            <button type="button" class="ghost-btn" [disabled]="currentPage === 0" (click)="prevPage()">‹</button>
            <button type="button" class="ghost-btn" [disabled]="currentPage >= totalPages - 1" (click)="nextPage()">›</button>
          </div>
        </div>
      </div>

      <!-- Side panel -->
      <div class="cmp__panel" [class.cmp__panel--open]="panelOpen">
        <app-cmp-form
          [mode]="formMode"
          [availableCoreVersions]="availableCoreVersions"
          (saved)="onFormSaved()"
          (cancelled)="closePanel()">
        </app-cmp-form>
      </div>
    </div>
  </section>

  <!-- Floating action menu -->
  <div class="action-menu"
       *ngIf="activeActionMenuId !== null && activeActionItem"
       [style.top.px]="actionMenuPosition.top"
       [style.left.px]="actionMenuPosition.left"
       (click)="$event.stopPropagation()">
    <div class="action-menu__arrow" [style.left.px]="actionMenuArrowOffset"></div>
    <button type="button" (click)="openEditPanel(activeActionItem!); closeActionMenu()">
      <span class="action-icon action-icon--edit" aria-hidden="true">
        <svg viewBox="0 0 20 20"><path d="M3 14.5V17h2.5L15.4 7.1l-2.5-2.5L3 14.5z"/><path d="M12.2 4.1l2.5 2.5 1.4-1.4c.4-.4.4-1 0-1.4L14 2.2c-.4-.4-1-.4-1.4 0l-1.4 1.9z"/></svg>
      </span>
      {{ 'cmp.actions.edit' | translate }}
    </button>
    <button type="button"
            (click)="deployConfig(activeActionItem!)"
            [disabled]="isDeploying.has(activeActionItem!.ID) || !activeActionItem!.Providers.length">
      <span class="action-icon action-icon--deploy" aria-hidden="true">
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M10 14V2M6 6l4-4 4 4" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 17h12" stroke-linecap="round"/></svg>
      </span>
      {{ isDeploying.has(activeActionItem!.ID) ? ('cmp.actions.deploying' | translate) : ('cmp.actions.deploy' | translate) }}
    </button>
    <button type="button"
            (click)="purgeCdn(activeActionItem!)"
            [disabled]="isPurging.has(activeActionItem!.ID)">
      <span class="action-icon action-icon--purge" aria-hidden="true">
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M4 10a6 6 0 1 1 1.5 4" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4 14v-4H8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      {{ isPurging.has(activeActionItem!.ID) ? ('cmp.purge.inProgress' | translate) : ('cmp.purge.action' | translate) }}
    </button>
    <button type="button" class="danger" (click)="deleteConfig(activeActionItem!); closeActionMenu()">
      <span class="action-icon action-icon--delete" aria-hidden="true">
        <svg viewBox="0 0 20 20"><path d="M6 6h8l-.8 10.5H6.8L6 6z"/><path d="M4 5h12"/><path d="M8 5V3h4v2"/></svg>
      </span>
      {{ 'cmp.actions.delete' | translate }}
    </button>
  </div>
</main>

<!-- Snippet modal -->
<div class="snippet-modal-overlay" *ngIf="snippetModal" (click)="closeSnippetModal()">
  <div class="snippet-modal" (click)="$event.stopPropagation()">

    <div class="snippet-modal__header">
      <div>
        <p class="snippet-modal__title">{{ 'cmp.snippet.title' | translate }} — {{ snippetModal.providerName }}</p>
        <p class="snippet-modal__subtitle">ProviderID: {{ snippetModal.providerID }}</p>
      </div>
      <button type="button" class="ghost-btn compact" (click)="closeSnippetModal()">×</button>
    </div>

    <div class="snippet-modal__body">
      <p class="snippet-modal__hint">{{ 'cmp.snippet.hint' | translate }}</p>
      <pre class="snippet-modal__pre"><code>{{ snippetModal.script }}</code></pre>
    </div>

    <div class="snippet-modal__footer">
      <a *ngIf="snippetModal.gcsUrl"
         [href]="snippetModal.gcsUrl"
         target="_blank"
         rel="noopener noreferrer"
         class="snippet-modal__gcs-link">
        {{ 'cmp.snippet.viewCmpJs' | translate }} →
      </a>
      <span *ngIf="!snippetModal.gcsUrl" class="snippet-modal__no-gcs">
        {{ 'cmp.snippet.notDeployed' | translate }}
      </span>
      <button type="button" class="ghost-btn snippet-modal__icon-btn"
              [title]="'cmp.snippet.download' | translate"
              (click)="downloadSnippet()">
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
          <path d="M10 3v10M6 9l4 4 4-4" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4 17h12" stroke-linecap="round"/>
        </svg>
      </button>
      <button type="button" class="ghost-btn snippet-modal__icon-btn"
              [title]="(snippetCopied ? 'cmp.snippet.copied' : 'cmp.snippet.copyClipboard') | translate"
              (click)="copySnippet()">
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
          <rect x="7" y="7" width="10" height="12" rx="1.5"/>
          <path d="M13 7V4.5A1.5 1.5 0 0 0 11.5 3h-7A1.5 1.5 0 0 0 3 4.5v10A1.5 1.5 0 0 0 4.5 17H7" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
  </div>
</div>
